import React from 'react';
import { fundingTypes } from '../../flows/shared/utils';
import styles from './styles.css';

const TrustConfirmation = ({ loadedData, fundingMethodType }) => {
  const openPDF = () => {
    try {
      window.open(loadedData?.formURL, '_blank');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  };

  const isExistingTrust =
    fundingMethodType === fundingTypes.FROM_EXISTING_ACCOUNT;

  const renderHeading = () =>
    isExistingTrust
      ? `Please complete these steps so we can finalize your transfer`
      : `To activate your account, complete these steps:`;

  const renderInstructions = () =>
    isExistingTrust ? (
      <strong>Print and sign the change of ownership form.</strong>
    ) : (
      <strong>Download and print the check form</strong>
    );

  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3>{renderHeading()}</h3>
          <ol>
            <li>
              {renderInstructions()}
              <p>
                <span className="download-form">
                  <span className="download-icon" />
                  <a
                    id="open-pdf-link"
                    role="button"
                    onClick={openPDF}
                    onKeyDown={openPDF}
                    tabIndex="0">
                    Download {isExistingTrust ? 'change of ownership' : 'check'}{' '}
                    form
                  </a>
                </span>
              </p>
            </li>
            <li>
              <strong>Make a copy of your trust document</strong>
            </li>
            <li>
              <strong>
                Mail your{' '}
                {isExistingTrust
                  ? 'change of ownership form'
                  : 'check, check form,'}{' '}
                and trust document via USPS to:
              </strong>
              <address>
                T. Rowe Price
                <br />
                P.O. Box 17150
                <br />
                Baltimore, MD 21297-1150
              </address>
            </li>
          </ol>

          <div className="disclaimer">
            <p>
              The cost basis method for this account has been defaulted to
              Average Cost. The cost basis method can impact the amount of
              taxable gain or loss when shares are sold. If you wish to make
              changes to this selection, log into your account and go to the My
              Profile section to learn more.
              {isExistingTrust && (
                <>
                  <br />
                  <br />
                  IMPORTANT: If the trustee information differs in any way from
                  the ownership information on the original account, you&apos;ll
                  need to obtain a medallion signature guarantee.
                  <br />
                  <br />
                  Most banks, savings institutions, and broker-dealers provide
                  this special signature guarantee required for securities
                  transfers. We cannot accept guarantees from notaries public or
                  non-medallion guarantors. The level of coverage provided by
                  the guarantor&apos;s stamp must cover the dollar amount of the
                  transaction or it may be rejected.
                </>
              )}
            </p>
          </div>
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

export default TrustConfirmation;
